export default "__VITE_ASSET__B0nOES58__"